import { Drawer } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';
import SideBar from './SideBar';

const SLayout = styled.div`
    /* padding: 15px; */
    width: 80vw;
`;

const DetailDrawer = ({ isShow, onClose = () => null, onFullViewShow = () => null }) => {
    return (
        <Drawer open={isShow} anchor={'right'} onClose={() => onClose()}>
            <SLayout>
                <SideBar isFullView onFullViewShow={(isShow) => onFullViewShow(isShow)} />
            </SLayout>
        </Drawer>
    );
};

export default DetailDrawer;
